<atomic-business-user
	[bold]="bold"
	[disabled]="disabled"
	[user]="user"
	[showName]="showName"
	[size]="size"
	[hideTooltip]="hideTooltip"
	[testHook]="testHooks.BusinessUser"
></atomic-business-user>
